<template>
  <router-view />
</template>

<script lang="ts" setup>
import { useI18n } from '@/i18n'
import { darkMode } from '@/preferences'
import { watchEffect } from 'vue'

const { locale } = useI18n()

watchEffect(() => {
  document.querySelector(':root')?.classList?.toggle('tw-dark', darkMode.value)
})

watchEffect(() => {
  document.documentElement.lang = locale.value
})
</script>
